export const CURRENT_STATUS_PENDING = 1
export const CURRENT_STATUS_POPULATING = 2
export const CURRENT_STATUS_RUNNING = 3
export const CURRENT_STATUS_COMPLETED = 4
